module.exports = __webpack_public_path__ + "img/ang6.16166952.png";